export const getDaysInMonth = (month, year = new Date().getFullYear()) => {
  return new Date(year, month, 0).getDate();
};

export const buildDayOptions = (month) => {
  const maxDay = month === 2 ? 28 : getDaysInMonth(month);
  return Array.from({ length: maxDay }, (_, index) => {
    const day = index + 1;
    return { label: String(day), value: day };
  });
};

export const buildMonthOptions = (locale = "fr") => {
  return Array.from({ length: 12 }, (_, index) => {
    const month = index + 1;
    const label = new Date(2000, index, 1).toLocaleDateString(locale, {
      month: "long",
    });
    return { label, value: month };
  });
};
